import { Navigate, Outlet, useParams } from 'react-router-dom'
import RefContext from '@/contexts/RefContext'
import { PATHS } from '@/router/paths'
import { isValidRef } from '@/lib/validation'

export default function RefLayout() {
	const { ref } = useParams<{ ref: string }>()

	if (!isValidRef(ref)) return <Navigate to={PATHS.notFound()} replace />

	return (
		<RefContext.Provider value={ref}>
			<Outlet />
		</RefContext.Provider>
	)
}
